import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { PAGE_SIZE_OPTIONS } from '../../../../Consts/backoffice.const';

@Component({
  selector: 'av-paginator',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule, TranslatePipe],
  templateUrl: './av-paginator.component.html',
  styleUrl: './av-paginator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class AvPaginatorComponent {
  readonly page = input.required<number>();
  readonly pageSize = input.required<number>();
  readonly total = input.required<number>();
  readonly disabled = input<boolean>(false);

  readonly pageChange = output<number>();
  readonly pageSizeChange = output<number>();

  readonly sizeOptions = PAGE_SIZE_OPTIONS;

  readonly pageCount = computed<number>(() =>
    Math.max(1, Math.ceil(this.total() / this.pageSize())),
  );

  readonly humanPage = computed<number>(() => this.page() + 1);

  readonly firstRow = computed<number>(() =>
    this.total() === 0 ? 0 : this.page() * this.pageSize() + 1,
  );

  readonly lastRow = computed<number>(() =>
    Math.min(this.total(), (this.page() + 1) * this.pageSize()),
  );

  readonly canGoBack = computed<boolean>(() => !this.disabled() && this.page() > 0);

  readonly canGoForward = computed<boolean>(
    () => !this.disabled() && this.page() + 1 < this.pageCount(),
  );

  previous(): void {
    if (this.canGoBack()) {
      this.pageChange.emit(this.page() - 1);
    }
  }

  next(): void {
    if (this.canGoForward()) {
      this.pageChange.emit(this.page() + 1);
    }
  }

  changeSize(value: string): void {
    this.pageSizeChange.emit(Number(value));
  }
}
